import styled from 'styled-components';
import { Checkbox } from '@/components/UI/Checkbox/Checkbox';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Container = styled.div`
  padding: 0 15px;
`;

export const CategoryCheckbox = styled(Checkbox)`
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};
`;

export const CategoryGroupName = styled(Typography.Caption).attrs({
  $variant: '2',
})`
  position: sticky;
  z-index: 1;
  top: 0;
  padding: 5px 15px 10px;
  color: ${({ theme }) => theme.palette.secondary.labels};
  background-color: ${({ theme }) => theme.palette.primary.background};

  &:not(:first-of-type) {
    padding-top: 30px;
  }
`;
